import { z } from 'zod';

import { EmailStringSchema } from '../../common';

export enum ContactRole {
  DECISION_MAKER = 'decision_maker',
  POINT_OF_CONTACT = 'point_of_contact',
}

export const ContactRoleSchema = z.nativeEnum(ContactRole, {
  invalid_type_error: 'Invalid contact role',
  required_error: 'Contact role is required',
});
export type ContactRoleType = z.infer<typeof ContactRoleSchema>;

export const ContactSchema = z.object({
  id: z.string().uuid(),
  firstName: z
    .string()
    .min(2, 'First name must be at least 2 characters')
    .max(100, 'First name must be less than 100 characters'),
  lastName: z
    .string()
    .min(2, 'Last name must be at least 2 characters')
    .max(100, 'Last name must be less than 100 characters'),
  emailAddress: EmailStringSchema.max(255, 'Email Address must be less than 255 characters'),
  role: ContactRoleSchema,
});

export type ContactRequestType = z.infer<typeof ContactSchema>;

export const ContactResponseSchema = z.array(ContactSchema);
export type ContactResponseType = z.infer<typeof ContactResponseSchema>;
